import { ByRoleMatcher, screen } from '@testing-library/preact';
import translations from '../../resources/nls/en/bundle';
import { RootEnvironment } from '#UNSAFE_Environment';

//TODO: JET-63873
export function getIcon(menuItem: HTMLElement, selector: string) {
  return menuItem.querySelector(selector);
}

export function getAllMenuItemsByRole(role: ByRoleMatcher, hidden = true) {
  return screen.getAllByRole(role, { hidden });
}

export function getMenuItemByRole(role: ByRoleMatcher, hidden = true) {
  return screen.getByRole(role, { hidden });
}

export function getLabel(label: string) {
  return screen.getByText(label);
}

export function setObserverConfig() {
  if (!window.ResizeObserver) {
    // ResizeObserver isn't available in test environment
    const MockResizeObserver = jest.fn();
    MockResizeObserver.mockReturnValue({
      observe: () => null,
      unobserve: () => null,
      disconnect: () => null
    });

    Object.defineProperty(global, 'ResizeObserver', {
      writable: true,
      configurable: true,
      value: MockResizeObserver
    });
  }
}

export const menuEnv: Partial<RootEnvironment> = {
  translations: { '@oracle/oraclejet-preact': translations },
  mode: 'test'
};
